import { countries } from 'countries-list/cjs'

export const COUNTRY_OPTIONS = Object.entries(countries)
  .map(([code, data]) => ({
    key: data.name,
    value: code,
    label: data.name,
  }))
  .sort((a, b) => a.label.localeCompare(b.label))

